import { render, staticRenderFns } from "./GerenciaReferencia.vue?vue&type=template&id=5a5a5c6a"
import script from "./GerenciaReferencia.vue?vue&type=script&lang=js"
export * from "./GerenciaReferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports